/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

export enum WebsocketProviders {
  FAYE = 'faye',
}
export interface IWebSocketClient {
  initialize(namespace: string, websocketUrl: string, authUrl: string): void;
  subscribe<T>(channelUrl: string, handler: (data: T) => void): Subscription | undefined;
}

export type EventHandler<T> = (event: T) => void;

// from https://github.com/faye/faye/blob/4778552e834c07e24ca24043dd95c99e73d62768/src/protocol/subscription.js
export interface Subscription {
  cancel(): void;
  unsubscribe(): void; // alias for cancel
}
